import { Component, inject } from '@angular/core';
import { AppConfig } from 'src/app/app-config.loader';
import { AnagraficaClassificheService } from 'src/app/core/anagrafica-classifiche.service';
import { AnagraficaQualificheService } from 'src/app/core/anagrafica-qualifiche.service';

@Component({
  selector: 'app-gestione-class-qual',
  template: `
    <div class="card card-w-title">
      <h1>
        Gestione classifiche, qualifiche
        @if (useSections) {
           e sezioni
        }
      </h1>
      <div class="grid">
        <div class="col-6">
            <app-anagrafica-classifica></app-anagrafica-classifica>
        </div>
        <div class="col-6">
          <app-anagrafica-editor [serviceType]="AnagraficaQualificheService" [itemTitle]="'Qualifica'"
            [nameProperty]="'nomeQualifica'"></app-anagrafica-editor>
        </div>
        <div class="col-12" [style.margin-top]="'30px'">
          <app-table-sezioni *ngIf="useSections"></app-table-sezioni>
        </div>
      </div>
    </div>
  `
})
export class GestioneClassQualComponent {
  public AnagraficaClassificheService = AnagraficaClassificheService;
  public AnagraficaQualificheService = AnagraficaQualificheService;

  private readonly appConfig = inject(AppConfig);
  public useSections = this.appConfig.logic.useSections
}
